module.exports = __webpack_public_path__ + "static/img/carddemo.ec8b446.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/card/carddemo.png
// module id = Nidu
// module chunks = 1